module.exports = __webpack_public_path__ + "static/media/s.5d4bd79a.svg";